import React, { useEffect, useRef, useState } from 'react';

export const templates = [
  {id:'decor',    name:'CasaNest',    label:'Home Decor',                  type:'Home Decor',              emoji:'🏠', image:'/templates/decor.jpg',    description:'Furniture, décor, lighting and beautiful everyday pieces.',         color:'template-decor',    products:['Sculptural Chair','Ceramic Vase','Accent Table']},
  {id:'gifts',    name:'Giftly',      label:'Gifts Store',                 type:'Gifts Store',             emoji:'🎁', image:'/templates/gifts.jpg',    description:'Curated gifts for birthdays, celebrations and special moments.',     color:'template-gifts',    products:['Gift Box','Candle Set','Mini Hamper']},
  {id:'pets',     name:'PetCart',     label:'Pet Products',                type:'Pet Products',            emoji:'🐶', image:'/templates/pets.jpg',     description:'Pet food, toys, accessories and everyday essentials.',               color:'template-pets',     products:['Dog Toy','Pet Shampoo','Treat Pack']},
  {id:'plants',   name:'GreenLeaf',   label:'Plants & Gardening',          type:'Plants & Gardening',      emoji:'🌱', image:'/templates/plants.jpg',   description:'Plants, pots, seeds and gardening products in a fresh layout.',      color:'template-plants',   products:['Monstera Plant','Ceramic Planter','Succulent']},
  {id:'grocery',  name:'FreshBasket', label:'Grocery Store',               type:'Grocery Store',           emoji:'🛒', image:'https://mir-s3-cdn-cf.behance.net/project_modules/max_1200/51d31e136807475.6200a91c64351.png', description:'Fresh groceries, weekly offers and easy product browsing.', color:'template-grocery', products:['Fresh Produce','Pantry Picks','Daily Essentials']},
  {id:'clothing', name:'UrbanStyle',  label:'Clothing Store',              type:'Clothing Store',          emoji:'👗', image:'/templates/clothing.jpg', description:'Collections, fashion products and editorial storefront sections.',    color:'template-clothing', products:['Linen Shirt','Everyday Dress','Leather Bag']},
  {id:'jewellery',name:'Lustre',      label:'Jewellery Store',             type:'Jewellery Store',         emoji:'💍', image:'/templates/jewellery.jpg',description:'A refined storefront for jewellery and premium accessories.',          color:'template-jewellery',products:['Gold Necklace','Statement Earrings','Classic Ring']},
  {id:'food',     name:'BakeBloom',   label:'Food & Bakery Store',         type:'Food & Bakery',           emoji:'🍰', image:'/templates/food.jpg',     description:'Cakes, bakery favourites, menus and special-order products.',         color:'template-food',     products:['Chocolate Cake','Butter Croissant','Berry Tart']},
  {id:'wellness', name:'PureCare',    label:'Personal Care & Wellness',    type:'Personal Care & Wellness',emoji:'🧴', image:'/templates/wellness.jpg', description:'Personal care, beauty and wellness products in a calm layout.',        color:'template-wellness', products:['Hydrating Serum','Moisturizer','Cleanser']}
];

export default function TemplateShowcase({ selectedTemplate, onChoose }) {
  const trackRef = useRef(null);
  const [paused, setPaused] = useState(false);
  const [userStopped, setUserStopped] = useState(false);
  const [active, setActive] = useState(0);

  const scrollByCard = (direction) => {
    const track = trackRef.current;
    if (!track) return;
    const card = track.querySelector('.template-card');
    const distance = card ? card.getBoundingClientRect().width + 22 : 360;
    track.scrollBy({ left: direction * distance, behavior: 'smooth' });
  };

  const handleManualScroll = (direction) => {
    setUserStopped(true); // stop auto-scroll permanently once user uses arrows
    scrollByCard(direction);
  };

  useEffect(() => {
    const track = trackRef.current;
    if (!track) return;
    const onScroll = () => {
      const card = track.querySelector('.template-card');
      if (!card) return;
      const width = card.getBoundingClientRect().width + 22;
      setActive(Math.round(track.scrollLeft / width) % templates.length);
    };
    track.addEventListener('scroll', onScroll, { passive: true });
    return () => track.removeEventListener('scroll', onScroll);
  }, []);

  const handlePreview = (templateId) => {
    localStorage.setItem('ownezzy_preview_template', templateId);
    window.open(`${window.location.origin}/preview?template=${templateId}`, '_blank');
  };

  return (
    <section className="section-pad templates-section" id="templates">
      <div className="container">
        <div className="template-heading-row">
          <div className="section-heading mb-0">
            <span className="section-kicker"><i className="bi bi-grid-3x3-gap" /> {templates.length} STORE DESIGNS</span>
            <h2>Choose a design <span>that fits your shop.</span></h2>
            <p>Browse storefront designs. Don't worry — you can change your design later anytime.</p>
          </div>
          <div className="template-carousel-controls">
            <button className="template-arrow" onClick={() => handleManualScroll(-1)} aria-label="Previous template"><i className="bi bi-arrow-left" /></button>
            <span><b>{String(active + 1).padStart(2, '0')}</b> / {String(templates.length).padStart(2, '0')}</span>
            <button className="template-arrow" onClick={() => handleManualScroll(1)} aria-label="Next template"><i className="bi bi-arrow-right" /></button>
          </div>
        </div>

        <div className="template-carousel-shell" onMouseEnter={() => setPaused(true)} onMouseLeave={() => setPaused(false)}>
          <div className="template-grid template-carousel-track" ref={trackRef}>
            {templates.map((t) => (
              <article
                className={`template-card ${selectedTemplate?.id === t.id ? 'selected' : ''}`}
                key={t.id}
                onClick={() => onChoose(t)}
                style={{ cursor: 'pointer' }}
              >
                <div className={`template-image ${t.color}`}>
                  <img
                    src={t.image}
                    alt={`${t.name} ${t.label} store template`}
                    loading="lazy"
                    decoding="async"
                    width="380"
                    height="230"
                    onError={(e) => { e.currentTarget.src = `/templates/${t.id}.svg`; }}
                  />
                  <div className="template-image-shade" />
                  <div className="template-store-top">
                    <span className="template-mini-logo">{t.name}</span>
                    <span className="template-mini-icons"><i className="bi bi-search" /><i className="bi bi-bag" /></span>
                  </div>
                  <span className="template-type-badge">{t.emoji} {t.label}</span>
                  <button
                    className="template-preview-badge"
                    aria-label={`Preview ${t.name} storefront template`}
                    onClick={(e) => { e.stopPropagation(); handlePreview(t.id); }}
                  >
                    <i className="bi bi-eye" /> Preview
                  </button>
                  {selectedTemplate?.id === t.id && (
                    <div className="template-selected-tick"><i className="bi bi-check-lg" /> Selected</div>
                  )}
                </div>
                <div className="template-body">
                  <div className="template-body-copy">
                    <span className="template-mini-category">{t.emoji} {t.label}</span>
                    <h3>{t.name}</h3>
                  </div>
                  <button
                    className={`btn w-100 template-use-btn ${selectedTemplate?.id === t.id ? 'btn-brand is-selected' : 'btn-outline-brand'}`}
                    onClick={(e) => { e.stopPropagation(); onChoose(t); }}
                  >
                    {selectedTemplate?.id === t.id ? (
                      <span><i className="bi bi-check-circle-fill" /> Selected Design</span>
                    ) : (
                      <span>Select this design <i className="bi bi-arrow-right" /></span>
                    )}
                  </button>
                </div>
              </article>
            ))}
          </div>
        </div>

        <div className="template-grid-note">
          <i className="bi bi-stars" /> {templates.length} responsive storefront designs &nbsp;·&nbsp; Free setup &nbsp;·&nbsp; Change design anytime
        </div>
      </div>
    </section>
  );
}
